export const CDN_URL_NO_PROTO =
    "//dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net";
export const CDN_URL = `https:${CDN_URL_NO_PROTO}`;
